/**
 * VENUE MODAL
 */

import React from 'react';

export default function VenueModal({ venue, isCheckedIn, checkinAt, onClose, onScanQR }) {
    if (!venue) return null;

    return (
        <div style={styles.overlay}>
            <div style={styles.modal}>
                <button style={styles.closeBtn} onClick={onClose}>✕</button>
                <div style={styles.icon}>{venue.icon}</div>
                <h2 style={styles.name}>{venue.name}</h2>
                <p style={styles.tagline}>{venue.tagline}</p>

                <div style={styles.info}>
                    <div style={styles.infoItem}>📍 {venue.address}, {venue.city}</div>
                    {venue.phone && <div style={styles.infoItem}>📞 {venue.phone}</div>}
                    {venue.website && <a href={venue.website} target="_blank" rel="noopener noreferrer" style={styles.infoItemLink}>🌐 Website</a>}
                </div>

                <p style={styles.description}>{venue.description}</p>

                <div style={styles.actionLinks}>
                    <a href={`https://www.google.com/maps/dir/?api=1&destination=${venue.latitude},${venue.longitude}`}
                        target="_blank" rel="noopener noreferrer" style={styles.secondaryBtn}>
                        🗺️ Get Directions
                    </a>
                    {venue.booking_url && (
                        <a href={venue.booking_url} target="_blank" rel="noopener noreferrer" style={styles.secondaryBtn}>
                            📅 Reserve a Tour
                        </a>
                    )}
                </div>

                {isCheckedIn ? (
                    <div style={styles.checkedIn}>
                        🏅 Already Checked In
                        <div style={styles.checkinDate}>{new Date(checkinAt).toLocaleDateString()}</div>
                    </div>
                ) : (
                    <button style={styles.scanBtn} onClick={onScanQR}>
                        📍 Check In & Earn Badge
                    </button>
                )}
            </div>
        </div>
    );
}

const styles = {
    overlay: {
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
        background: 'rgba(0,0,0,0.7)', display: 'flex',
        alignItems: 'flex-end', justifyContent: 'center', // Align to bottom for sheet style
        zIndex: 5000
    },
    modal: {
        background: '#fff8f0', width: '100%', maxWidth: 500,
        borderTopLeftRadius: 24, borderTopRightRadius: 24, // Rounded top corners
        padding: '32px 24px 60px', position: 'relative', textAlign: 'center',
        boxShadow: '0 -4px 20px rgba(0,0,0,0.15)',
        maxHeight: '90vh', overflowY: 'auto',
        animation: 'slideUp 0.3s ease-out forwards' // Slide up animation
    },
    closeBtn: { position: 'absolute', top: 16, right: 16, background: 'none', border: 'none', fontSize: 24, cursor: 'pointer', color: '#888' },
    icon: { fontSize: 64, marginBottom: 12 },
    name: { fontSize: 24, color: '#1c1010', marginBottom: 4 },
    tagline: { fontSize: 14, color: '#b8753d', fontStyle: 'italic', marginBottom: 20 },
    info: { display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 20, color: '#666', fontSize: 14 },
    infoItem: { color: '#666' },
    infoItemLink: { textDecoration: 'none', color: '#b8753d', fontWeight: 'bold' },
    description: { fontSize: 14, color: '#444', lineHeight: 1.6, marginBottom: 20, textAlign: 'left' },
    actionLinks: { display: 'flex', gap: 10, justifyContent: 'center', marginBottom: 24 },
    secondaryBtn: {
        flex: 1, padding: '12px 0', background: '#e0d8c8', color: '#444',
        borderRadius: 12, textDecoration: 'none', fontSize: 13, fontWeight: 'bold',
        display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6
    },
    scanBtn: { width: '100%', background: '#b8753d', color: '#fff', border: 'none', borderRadius: 12, padding: 16, fontSize: 16, fontWeight: 'bold', cursor: 'pointer' },
    checkedIn: { background: '#f0fff4', color: '#2e7d32', padding: 16, borderRadius: 12, fontWeight: 'bold' },
    checkinDate: { fontSize: 12, opacity: 0.8, marginTop: 4 }
};

// Add slide-up animation globally if not present
if (typeof document !== 'undefined') {
    const style = document.createElement('style');
    style.innerHTML = `
        @keyframes slideUp {
            from { transform: translateY(100%); opacity: 0; }
            to { transform: translateY(0); opacity: 1; }
        }
    `;
    document.head.appendChild(style);
}
